import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './index.scss';
import {
  STATUS_CODE_MAP,
  subStatusData
} from '../../pages/tm/investigation/metaUtils';
import { ConfigData } from '../../util/ABUtil';

/**
 * This is the Single Status Code Component for Filters
 * @param status
 * @param activeIndex
 * @param handleClick
 * @param filterData
 * @returns {span}
 * @constructor
 */
const SingleStatusComponent = ({
  status,
  activeIndex,
  handleClick,
  filterData
}) => {
  const { text, statusCode, name } = status;
  return (
    <span
      key={`${text}-${statusCode}`}
      className={classnames(
        style.presetSpan,
        activeIndex === statusCode ? style.presetSpanActive : ''
      )}
      onClick={() => {
        handleClick(statusCode);
      }}>
      {text}
      <small> ({filterData[name]})</small>
    </span>
  );
};

const SingleSubStatusComponent = ({
  status,
  handleClick,
  activeIndex,
  filterData
}) => {
  const { text, statusCode, name } = status;
  return (
    <span
      key={`${text}-${statusCode}`}
      className={classnames(
        style.presetSpanSubstatus,
        activeIndex === statusCode ? style.presetSpanSubstatusActive : ''
      )}
      onClick={() => {
        handleClick(statusCode);
      }}>
      <i
        className={classnames(style.dotIndicator)}
        style={{ background: indicatorColorGenerator(name) }}
      />
      &nbsp;{text}
      <small> ({filterData[name]})</small>
    </span>
  );
};

/**
 * This is a Status Filter for Alerts/Anomalies eg OPEN/CLOSE/ASSIGNED/CLOSED
 * @param props
 * @returns {div}
 * @constructor
 */
const StatusFilter = (props) => {
  const { filterData, activeIndex, handleClick } = props;
  if (
    !STATUS_CODE_MAP ||
    !filterData ||
    activeIndex === null ||
    activeIndex === undefined
  ) {
    return null;
  }

  let spanElements = [];
  STATUS_CODE_MAP.filter((item) => {
    if (ConfigData.IS_NCD_NOT_AVAILABLE) {
      return item.isNotAnamoly;
    } else {
      return item;
    }
  }).forEach((status) => {
    spanElements.push(
      <SingleStatusComponent
        status={status}
        activeIndex={activeIndex}
        handleClick={handleClick}
        filterData={filterData}
      />
    );
  });

  return <div className={style.statusFilter}>{spanElements}</div>;
};

/**
 * propTypes
 * @type {{activeIndex: shim, filterData: shim, handleClick: shim, statusData: shim}}
 */
StatusFilter.propTypes = {
  statusData: PropTypes.array,
  filterData: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  handleClick: PropTypes.func
};

/**
 * This is SubStatus Filter Component
 * @param props
 * @returns {div}
 * @constructor
 */
const SubStatusFilters = (props) => {
  const { filterData, activeIndex, handleClick } = props;
  if (
    !subStatusData ||
    !filterData ||
    activeIndex === null ||
    activeIndex === undefined
  ) {
    return null;
  }

  let spanElements = [];
  if (!ConfigData.IS_NCD_NOT_AVAILABLE) {
    subStatusData.forEach((status) => {
      spanElements.push(
        <SingleSubStatusComponent
          status={status}
          activeIndex={activeIndex}
          handleClick={handleClick}
          filterData={filterData}
        />
      );
    });
  }
  return <div className={style.statusFilter}>{spanElements}</div>;
};

/**
 * PropTypes
 * @type {{activeIndex: shim, filterData: shim, handleClick: shim, statusData: shim}}
 */
SubStatusFilters.propTypes = {
  statusData: PropTypes.array,
  filterData: PropTypes.object.isRequired,
  activeIndex: PropTypes.number,
  handleClick: PropTypes.func
};

/**
 * Accepts string to check if alert or anomaly and returns color on basis of it
 * @param s
 * @returns {string}
 */
const indicatorColorGenerator = (s) => {
  if (s === 'alert') {
    return '#E85252';
  }

  if (s === 'anomaly' || s === 'anomlay') {
    return '#BC23DA';
  }
  return '#fff';
};

export { StatusFilter, SubStatusFilters };
